import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './Accordions.scss';

function Accordion({ children, size, type, liveData }) {
    const accordionType = type === 'radio' ? 'r' : 'c';

    const key = liveData ? new Date().getTime() : 'accordion';

    return (
        <div key={key} className={styles[`accordion-${accordionType}-${size}`]}>
            {React.Children.map(children, child => React.cloneElement(child, { size, type }))}
        </div>
    );
}

Accordion.displayName = displayName('Accordions/Accordion');

/* eslint-disable react/require-default-props */

Accordion.propTypes = {
    children(props, propName, componentName) {
        const prop = props[propName];
        const baseErrorMsg = `\`${componentName}\` children`;

        let error = null;
        if (!React.Children.count(prop)) {
            error = new Error(`${baseErrorMsg} are required`);
        }
        return error;
    },
    size: PropTypes.oneOf(['small', 'large']),
    type: PropTypes.oneOf(['checkbox', 'radio']),
    liveData: PropTypes.bool,
};

Accordion.defaultProps = {
    size: 'large',
    type: 'checkbox',
    liveData: false,
};

export default Accordion;
